import { render, staticRenderFns } from "./ImportarPlanoSaude.vue?vue&type=template&id=5881f66e"
import script from "./ImportarPlanoSaude.vue?vue&type=script&lang=ts"
export * from "./ImportarPlanoSaude.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports